/* ══════════════════════════════════════════════════════════════════
   公告条：倒计时 + 到货日。
   两件事都必须在浏览器里算，不能在 Liquid 里算 ——
   section 的 HTML 是缓存的，Liquid 里的「现在」是渲染那一刻，
   缓存一过夜就开始骗人。访客自己的时钟永远是对的。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── 工作日推算：跳过周六日 ────────────────────────────────────
     from 当天不算，从下一个工作日开始数。 */
  function addWorkingDays(from, days) {
    var d = new Date(from.getTime());
    var left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) left--;
    }
    return d;
  }

  /* 今天过了截单点、或者今天本来就是周末 → 从下一个工作日才开始发货 */
  function dispatchFrom(now, cutoffHour) {
    var d = new Date(now.getTime());
    var wd = d.getDay();
    var late = d.getHours() >= cutoffHour;
    if (late || wd === 0 || wd === 6) {
      do {
        d.setDate(d.getDate() + 1);
        wd = d.getDay();
      } while (wd === 0 || wd === 6);
      d.setHours(9, 0, 0, 0);
    }
    return d;
  }

  function fmt(date, locale) {
    try {
      return new Intl.DateTimeFormat(locale || undefined, {
        weekday: 'short', day: 'numeric', month: 'short'
      }).format(date);
    } catch (e) {
      return date.toDateString();
    }
  }

  function mountEta(el) {
    var min = parseInt(el.getAttribute('data-eta-min'), 10);
    var max = parseInt(el.getAttribute('data-eta-max'), 10);
    var cutoff = parseInt(el.getAttribute('data-eta-cutoff'), 10);
    var locale = el.getAttribute('data-eta-locale');
    var template = el.getAttribute('data-eta-template') || '%%';
    var out = el.querySelector('[data-eta-text]');
    if (!out || isNaN(min) || isNaN(max)) return;

    var now = new Date();
    var start = dispatchFrom(now, isNaN(cutoff) ? 14 : cutoff);
    var first = addWorkingDays(start, min);
    var last = addWorkingDays(start, max);

    var window_;
    if (first.toDateString() === last.toDateString()) {
      window_ = fmt(first, locale);
    } else {
      window_ = fmt(first, locale) + ' – ' + fmt(last, locale);
    }
    /* 模板里的 %% 换成日期段，日期本身加粗 */
    out.innerHTML = template.replace('%%', '<b>' + window_ + '</b>');
  }

  /* ── 倒计时 ──────────────────────────────────────────────────── */
  var clocks = [];

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function mountCountdown(el) {
    var end = new Date(el.getAttribute('data-cd-end'));
    if (isNaN(end.getTime())) return;
    clocks.push({
      el: el,
      end: end,
      hide: el.getAttribute('data-cd-hide') === 'true',
      clock: el.querySelector('[data-cd-clock]'),
      done: el.querySelector('[data-cd-done]'),
      vals: {
        d: el.querySelector('[data-cd-unit="d"] [data-cd-val]'),
        h: el.querySelector('[data-cd-unit="h"] [data-cd-val]'),
        m: el.querySelector('[data-cd-unit="m"] [data-cd-val]'),
        s: el.querySelector('[data-cd-unit="s"] [data-cd-val]')
      },
      last: -1
    });
    el.hidden = false;
  }

  function tick() {
    var now = Date.now();
    for (var i = 0; i < clocks.length; i++) {
      var c = clocks[i];
      var left = c.end.getTime() - now;

      if (left <= 0) {
        if (c.hide) { c.el.hidden = true; continue; }
        if (c.clock) c.clock.hidden = true;
        if (c.done) c.done.hidden = false;
        c.el.classList.remove('is-urgent');
        continue;
      }

      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var ss = s % 60;

      if (c.vals.d) c.vals.d.textContent = String(d);
      if (c.vals.h) c.vals.h.textContent = pad(h);
      if (c.vals.m) c.vals.m.textContent = pad(m);
      if (c.vals.s) c.vals.s.textContent = pad(ss);

      /* 秒跳的时候轻轻收一下，只收秒 */
      if (ss !== c.last) {
        c.last = ss;
        c.el.classList.add('is-tick');
        window.setTimeout(function (node) {
          return function () { node.classList.remove('is-tick'); };
        }(c.el), 140);
      }

      c.el.classList.toggle('is-urgent', left < 3600000);
    }
  }

  function init(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-eta]'), mountEta);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-countdown]'), function (el) {
      if (el.dataset.cdReady === '1') return;
      el.dataset.cdReady = '1';
      mountCountdown(el);
    });
    if (clocks.length && !init.timer) {
      tick();
      init.timer = window.setInterval(tick, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    clocks = clocks.filter(function (c) { return document.body.contains(c.el); });
    init(e.target);
  });
})();
